import React, { useEffect } from 'react';
import StoreLinkCard from '../components/StoreLinkCard';
import { STORE_LINKS } from '../constants/storeLinks';
import './StoreLinksPage.css';

export default function StoreLinksPage() {
  useEffect(() => {
    document.title = 'Ünmak Mobil — Mağaza Linkleri';
  }, []);

  return (
    <div className="store-links-page">
      <div className="store-links-shell">
        <header className="store-links-header">
          <img src="/assets/img/logo.png" alt="Ünmak" className="store-links-logo" />
          <h1>Ünmak Mobil</h1>
          <p>Cihazınıza uygun mağazadan uygulamayı indirin.</p>
        </header>

        <div className="store-links-grid">
          {STORE_LINKS.map((item) => (
            <StoreLinkCard key={item.id} {...item} />
          ))}
        </div>

        <footer className="store-links-footer">
          <span>unmak.tech/stores</span>
        </footer>
      </div>
    </div>
  );
}
